<template lang='slm'>
  .container-fluid.table-responsive
    .text-left.mb-2
      button.btn.btn-success.mr-2 type='button' @click='loadQuestions(-1)' :disabled='offset <= 0' Более поздние вопросы
      span.mr-2 Страница {{ (offset / limit) + 1 }}
      button.btn.btn-success type='button' @click='loadQuestions(1)' Более ранние вопросы
    table.table.table-bordered
      thead
        tr
          th style='width:1%' Имя
          th Вопрос
          th style='width:25%' Ответ
      tbody
        tr v-for='question in items'
          td
            strong.text-nowrap  {{ question.name }}
            .text-nowrap {{ question.insertedAt | datetime }}
          td {{ question.question }}
          td
            template v-if='question.userId === null'
              span Вопрос ни на кого не назначен
              .d-block
                button.btn.btn-sm.btn-warning type='button' @click='linkUserToQuestion(question.id)' Ответить
            template v-else-if='question.answer'
              icon.mr-2 :name='question.answer ? "regular/check-square" : "regular/square"'
              span Вопрос отвечен
              .d-block
                button.btn.btn-sm.btn-primary type='button' @click='openModalToShowExistingAnswer(question.id)' Показать ответ
            template v-else-if='currentUser.id === question.userId'
              span Вопрос назначен на вас, но ещё не отвечен
              .d-block
                button.btn.btn-sm.btn-warning type='button' @click='openModalToAnswerQuestion(question.id)' Ответить
            template v-else='' Вопрос назначен на {{ users | findFor('id', question.userId) | userName }}, но  ещё не отвечен

    modal ref='answerModal' @confirm='answerQuestion' title='Анонимный вопрос' size='lg'
      admin-question-modal-content
    modal ref='showAnswerModal' title='Анонимный вопрос' size='lg' :showConfirmButton='false'
      admin-question-modal-content
</template>

<script>
import gql from 'graphql-tag';
import Modal from '@/components/Modal';
import AdminQuestionModalContent from './_AdminQuestionModalContent';

const ITEMS_QUERY_LIMIT = 30;
const ITEM_FIELDS = 'id name question answer userId insertedAt previousQuestions { question answer }';
const GET_DATA_QUERY = gql`query ($limit: Int!, $offset: Int!) { questions(limit: $limit, offset: $offset) { ${ITEM_FIELDS} } }`;

export default {
  name: 'AdminQuestions',
  components: { Modal, AdminQuestionModalContent },
  props: {
    currentUser: {
      type: Object,
      required: true,
    },
  },
  apollo: {
    data: {
      client: 'admin',
      query: GET_DATA_QUERY,
      update(data) {
        this.items = data.questions;
      },
      variables() {
        return {
          limit: ITEMS_QUERY_LIMIT,
          offset: this.offset,
        };
      },
    },
    users: {
      client: 'admin',
      query: gql`{ users { id name } }`,
    },
  },
  data() {
    return {
      offset: 0,
      limit: ITEMS_QUERY_LIMIT,
      users: [],
      items: [],
    };
  },
  filters: {
    findFor(objects, field, value) {
      return objects.find(o => o[field] === value);
    },
    userName(user) {
      if (!user) {
        return '––';
      }
      return user.name;
    },
  },
  methods: {
    async linkUserToQuestion(questionId) {
      await this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation LinkCurrentUserToQuestion($questionId: Int!) { linkCurrentUserToQuestion(questionId: $questionId) { ${ITEM_FIELDS} } }`,
        variables: {
          questionId,
        },
        update: (store, { data: { linkCurrentUserToQuestion: updatedQuestion } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY, variables: { limit: ITEMS_QUERY_LIMIT, offset: this.offset } });
          const index = data.questions.findIndex(question => question.id === updatedQuestion.id);
          if (index !== -1) {
            data.questions[index] = updatedQuestion;
          }
          store.writeQuery({ query: GET_DATA_QUERY, variables: { limit: ITEMS_QUERY_LIMIT, offset: this.offset }, data });
        },
      });
      this.openModalToAnswerQuestion(questionId);
    },
    loadQuestions(multiplier) {
      this.offset += ITEMS_QUERY_LIMIT * multiplier;
    },
    openModalToAnswerQuestion(questionId) {
      const question = this.items.find(q => q.id === questionId);
      if (!question) {
        return;
      }
      this.$refs.answerModal.open({ question });
    },
    openModalToShowExistingAnswer(questionId) {
      const question = this.items.find(q => q.id === questionId);
      if (!question) {
        return;
      }
      this.$refs.showAnswerModal.open({ question, readonly: true });
    },
    async answerQuestion({ id, answer }) {
      await this.$apollo.mutate({
        client: 'admin',
        mutation: gql`mutation AnswerQuestion($questionId: Int!, $answer: String!) { answerQuestion(questionId: $questionId, answer: $answer) { ${ITEM_FIELDS} } }`,
        variables: {
          questionId: id,
          answer,
        },
        update: (store, { data: { answerQuestion: updatedQuestion } }) => {
          const data = store.readQuery({ query: GET_DATA_QUERY, variables: { limit: ITEMS_QUERY_LIMIT, offset: this.offset } });
          const index = data.questions.findIndex(question => question.id === updatedQuestion.id);
          if (index !== -1) {
            data.questions[index] = updatedQuestion;
          }
          store.writeQuery({ query: GET_DATA_QUERY, variables: { limit: ITEMS_QUERY_LIMIT, offset: this.offset }, data });
        },
      });
      this.$refs.answerModal.close();
      this.$refs.showAnswerModal.close();
    },
  },
};
</script>
